import { render } from "./Checkbox.vue?vue&type=template&id=bac7c7f8"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=bac7c7f8&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script